import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import {
  IDealerContractDetail,
  IDealerContractFilter,
  IDealerContractListItem,
  IDealerContractRejectRequest,
} from '../models/dealerContractAdminModels'

/** Filtreler queryParams ile gönderilir (backend [FromQuery] DealerContractFilterModel). */
export class GetDealerContractListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealer-contract/list',
      requesterInfo,
    })
  }

  public async getList(filter: IDealerContractFilter): Promise<IDealerContractListItem[]> {
    const params = new KeyValuePair<any>()
    if (filter.Status !== undefined && filter.Status !== null) params.add('Status', filter.Status)
    if (filter.SapCode) params.add('SapCode', filter.SapCode)
    if (filter.StartDate) params.add('StartDate', filter.StartDate)
    if (filter.EndDate) params.add('EndDate', filter.EndDate)
    if (filter.DealerType) params.add('DealerType', filter.DealerType)
    this.queryParams = params

    return await this.getAsync<IDealerContractListItem[]>()
  }
}

/** Kayıt + kronolojik hareket geçmişi (red gerekçeleri, bilgi diff'i, belge sürümleri). */
export class GetDealerContractDetailApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealer-contract/detail',
      requesterInfo,
    })
  }

  public async getDetail(id: number): Promise<IDealerContractDetail> {
    return await this.getAsync<IDealerContractDetail>(String(id))
  }
}

export class ApproveDealerContractApi extends ClientProxy {
  constructor(id: number, requesterInfo: IRequesterInfo) {
    super({
      url: `admin/dealer-contract/approve/${id}`,
      requesterInfo,
    })
  }

  public async approve(): Promise<boolean> {
    return await this.postAsync<boolean>({})
  }
}

/**
 * Red kapsamı bayinin ne yapacağını belirler: Belge (1) yalnız belge yeniden yüklenir,
 * Bilgi (2) veya Belge+Bilgi (3) ise sözleşme de yeniden onaylatılır.
 */
export class RejectDealerContractApi extends ClientProxy {
  constructor(id: number, requesterInfo: IRequesterInfo) {
    super({
      url: `admin/dealer-contract/reject/${id}`,
      requesterInfo,
    })
  }

  public async reject(request: IDealerContractRejectRequest): Promise<boolean> {
    return await this.postAsync<boolean>(request)
  }
}
